<template>
  <section class="app-main">
    <!-- <transition name="fade-transform" mode="out-in"> -->
      <!-- <router-view :key="key" /> -->
      <router-view  />
      <!-- <WarningNotice></WarningNotice> -->
    <!-- </transition> -->
  </section>
</template>

<script>
// import WarningNotice from '../../monitor/WarningNotice'

export default {
  name: 'AppMain',
  components:{
    // WarningNotice
  },
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scpoed>
  .app-main {
    position: relative;
    /* overflow: hidden; */
    /* float: left; */
    /* navbar 高度为40px */
    min-height: calc(100vh - 40px);
  }
</style>
